<template>
  <div
    v-if="slideProducts.length !== 0"
    class="swiper-products"
    :class="{ 'swiper-products--loading': loading }">
    <div class="swiper-products__title">
      <span>{{ overlineTitle }}</span>
    </div>

    <div
      v-swiper-products="slideProducts"
      class="swiper-container swiper-container--products">
      <div 
        v-lazy-container="{ selector: 'img' }"
        class="swiper-wrapper">
        <!-- Slides -->
        <router-link
          :to="{ name: `${lang}.single-product`, params: { slug: slide.fields.slug } }"
          class="swiper-slide"
          v-for="(slide, index) of slideProducts"
          :key="index">
            <img
              :data-src="slide.fields.imageCarousel.fields.file.url"
              :data-loading="lazyLoading"
              :alt="slide.fields.imageCarousel.fields.description"
              :width="slide.fields.imageCarousel.fields.file.details.image.width"
              :height="slide.fields.imageCarousel.fields.file.details.image.height">
            <div class="swiper-products__text-area">
              <div v-html="$_getDescriptionCarousel(slide.fields.descriptionCarousel)"></div>
              <span>{{ $t('common.discover') }}</span>
            </div>
        </router-link>
        <!-- Fine Slides -->
      </div>
      <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { mapGetters, mapActions } from 'vuex'
import swiper from './swiper'

export default {
  name: 'SwiperProducts',
  mixins: [swiper],
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/home-products-swiper.png'),
  }),
  props: {
    overlineTitle: {
      type: String,
      required: false
    },
    shownProducts: {
      type: Number,
      default: () => 5
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'products'
    ]),
    ...mapGetters([
      'lang'
    ]),
    slideProducts: {
      get () {
        return this.products
          .filter((product) => typeof product.fields.imageCarousel !== 'undefined')
          .slice(0, this.shownProducts - 1)
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_getDescriptionCarousel (content) {
      if (content === undefined) return ''
      return documentToHtmlString(content)
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
